import { Link } from 'react-router-dom';

const baseStyles = {
  solid: 'group inline-flex items-center justify-center py-3 px-7 text-sm font-semibold focus:outline-none transition-all duration-200',
  outline: 'group inline-flex items-center justify-center py-3 px-6 text-sm font-semibold focus:outline-none transition-all duration-200',
};

const variantStyles = {
  solid: {
    coral: 'bg-gradient-to-br from-gch-cta to-gch-cta-dark text-white border-2 border-gch-accent/60 rounded-[14px] shadow-[0_4px_12px_rgba(229,106,84,0.3)] hover:brightness-105 hover:shadow-[0_6px_20px_rgba(229,106,84,0.4)] focus-visible:ring-2 focus-visible:ring-gch-accent focus-visible:ring-offset-2 focus-visible:ring-offset-gch-bg',
    slate: 'bg-gradient-to-br from-gch-cta to-gch-cta-dark text-white border-2 border-gch-accent/60 rounded-[14px] shadow-[0_4px_12px_rgba(229,106,84,0.3)] hover:brightness-105 hover:shadow-[0_6px_20px_rgba(229,106,84,0.4)] focus-visible:ring-2 focus-visible:ring-gch-accent',
    blue: 'bg-gradient-to-br from-gch-cta to-gch-cta-dark text-white border-2 border-gch-accent/60 rounded-[14px] shadow-[0_4px_12px_rgba(229,106,84,0.3)] hover:brightness-105 hover:shadow-[0_6px_20px_rgba(229,106,84,0.4)] focus-visible:ring-2 focus-visible:ring-gch-accent',
    white: 'bg-gch-surface text-white border border-gch-border rounded-xl hover:bg-gch-surface/80 focus-visible:ring-2 focus-visible:ring-gch-accent',
  },
  outline: {
    slate: 'border border-white/45 bg-transparent text-white/95 rounded-xl hover:bg-white/14 hover:border-white/70 focus-visible:ring-2 focus-visible:ring-gch-accent',
    white: 'border border-white/45 bg-transparent text-white/95 rounded-xl hover:bg-white/14 hover:border-white/70 focus-visible:ring-2 focus-visible:ring-gch-accent',
  },
};

export function Button({ className = '', variant = 'solid', color = 'coral', href, to, ...props }) {
  const isHash = typeof href === 'string' && href.startsWith('#');
  const isInternalPath = (h) => typeof h === 'string' && h.startsWith('/');
  const linkTo = to ?? (href && isInternalPath(href) ? href : null);
  const isExternal = href && !isHash && !linkTo;
  const styleClass = variant === 'outline'
    ? (variantStyles.outline[color] || variantStyles.outline.white)
    : (variantStyles.solid[color] || variantStyles.solid.coral);
  const classes = `${baseStyles[variant]} ${styleClass} ${className}`.trim();

  if (linkTo) return <Link to={linkTo} className={classes} {...props} />;
  if (isHash) return <a href={href} className={classes} {...props} />;
  if (isExternal) return <a href={href} className={classes} target="_blank" rel="noopener noreferrer" {...props} />;
  return <button type="button" className={classes} {...props} />;
}
